import { rootApi } from '../rootApi';

export const vehicleWarrantyInformationReportApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getVehicleWarrantyInformation: builder.query({
      query: (params) => ({
        url: 'v1/vehiclewarrantyinformation/getall',
        method: 'GET',
        params: {
          SasiNo: params?.sasiNo ? String(params.sasiNo).trim() : undefined,
          ZNumber: params?.zNumber ?? undefined,
          PageNumber: params?.pageNumber ?? 1,
          PageSize: params?.pageSize ?? 10,
        },
      }),
      transformResponse: (response) => {
        if (response?.data && Array.isArray(response.data.items)) {
          return { items: response.data.items, totalCount: response.data.totalCount ?? 0 };
        }
        return { items: [], totalCount: 0 };
      },
      providesTags: ['VehicleWarrantyInformation'],
    }),
 getWarrantyInformationByChassisNo: builder.query({
      query: ({ sasiNo }) => ({
        url: '/v1/vehiclewarrantyinformation/getbychassisno',
        method: 'GET',
        params: {
          SasiNo: sasiNo
        }
      }),
      transformResponse: (response) => {
        if (response?.data?.item) {
          return response.data.item;
        }
        return null;
      },
      providesTags: ['VehicleWarrantyInformation'],
    }),
    exportVehicleWarrantyInformationToExcel: builder.query({
        query: (body) => ({
            url: 'v1/vehiclewarrantyinformation/exportwarrantyinformationtoexcel',
            method: 'POST',
            body: {
                sasiNo:          body.sasiNo          ?? null,
                zNumber:         body.zNumber          ?? null,
                LanguageId:      body.LanguageId,
                compressionType: 0, // direkt excel, zip yok
            }
        }),
        transformResponse: (response) => {
            if (response?.isSuccessful && response?.data) {
                const { fileBase64, fileName, contentType, recordCount, isCompressed, compressionType } = response.data;
                return { fileBase64, fileName, contentType, recordCount, isCompressed, compressionType };
            }
            throw new Error(response?.errorMessage || 'Export başarısız oldu');
        }
    }),
  }),
});

export const {
  useGetVehicleWarrantyInformationQuery,
  useLazyGetVehicleWarrantyInformationQuery,
  useGetWarrantyInformationByChassisNoQuery,
  useLazyGetWarrantyInformationByChassisNoQuery,
  useLazyExportVehicleWarrantyInformationToExcelQuery,
} = vehicleWarrantyInformationReportApi;
